import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import './index.css'
import './components/GoldBanner.css'
import './i18n'
import App from './App.jsx'

import ErrorFallback from './components/ErrorFallback'
import { initTelemetry } from './services/telemetry';
import { initCapacitor } from './utils/capacitorInit'

initCapacitor();

initTelemetry();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => <ErrorFallback error={error} resetError={resetError} />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
import './styles/cards.css';
